export default __webpack_public_path__ + "static/media/cr_hadoop.c1b6215d.jpg";